import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';

// Composants
import { BaseComponent } from '../abstract/base.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from '../../models/subscription/subscription.model';

// enums
import { FeaturesEnum } from '../../enums/features.enum';

@Component({
    selector: 'app-locked-feature-dialog',
    imports: [
        ButtonModule,
    ],
    templateUrl: './locked-feature-dialog.component.html',
    styleUrl: './locked-feature-dialog.component.scss'
})
export class LockedFeatureDialogComponent extends BaseComponent {
    private _config = inject(DynamicDialogConfig);
    private _ref = inject(DynamicDialogRef);


    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/



    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _featureCode!: string;

    private _subscription!: Subscription;
    public get subscription(): Subscription {
        return this._subscription;
    }
    public set subscription(value: Subscription) {
        this._subscription = value;
    }

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    public get featureDescription(): string {
        switch (this._featureCode) {
            case (FeaturesEnum.Accounting):
                return "votre comptabilité";
            case (FeaturesEnum.AutoBanking):
                return "synchroniser automatiquement vos opérations bancaires";
            case (FeaturesEnum.Banking):
                return "gérer vos opérations bancaires";
            case (FeaturesEnum.BankMatching):
                return "rapprocher vos opérations bancaires";
            case (FeaturesEnum.Cheques):
                return "saisir vos chèques";
            case (FeaturesEnum.Dashboard):
                return "accéder à votre tableau de bord";
            case (FeaturesEnum.EmailCollection):
                return "collecter vos factures par email";
            case (FeaturesEnum.Expenses):
                return "gérer vos dépenses";
            case (FeaturesEnum.Loans):
                return "gérer vos prêts";
            case (FeaturesEnum.Ocr):
                return "saisir automatiquement vos factures";
            case (FeaturesEnum.ProductCategories):
                return "gérer vos produits";
            case (FeaturesEnum.PurchaseInvoices):
                return "gérer vos achats";
            case (FeaturesEnum.PurchasePayments):
                return "gérer vos paiements";
            case (FeaturesEnum.RecurringInvoices):
                return "gérer vos factures récurrentes";
            case (FeaturesEnum.SalesEmails):
                return "envoyer vos factures par email";
            case (FeaturesEnum.SalesEmailsNoLogo):
                return "envoyer vos factures par email";
            case (FeaturesEnum.SalesInvoices):
                return "gérer vos ventes";
            case (FeaturesEnum.SalesPayments):
                return "gérer vos paiements";
            case (FeaturesEnum.SalesQuotations):
                return "gérer vos devis";
            case (FeaturesEnum.Tgc):
                return "gérer votre TGC";
            case (FeaturesEnum.WidgetBank):
                return "visualiser votre trésorerie";
            case (FeaturesEnum.WidgetCharges):
                return "visualiser vos charges";
            case (FeaturesEnum.WidgetPurchaseInvoices):
                return "visualiser vos achats";
            case (FeaturesEnum.WidgetSalesInvoices):
                return "visualiser vos ventes";
            default:
                return "accéder à cette fonctionnalité";
        }
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    constructor() {
        super();
        this._featureCode = this._config.data.featureCode;
        this.subscription = this._config.data.subscription;
        this._config.header += `${this.featureDescription} ?`;
    }

    public onClickGoToSubscriptions(): void {
        this.router.navigate([this.appService.clientUrl('/settings/client/subscription')]);
        this._ref.close();
    }

    public onClose(): void {
        this._ref.close();
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/



    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

}
